import * as React from 'react';
import FancyTitle from '../fancy-title';
import { loadExternalScript } from '../../lib/utils';

export default function SpecialistForm({ blok }) {
  const {
    title,
    subtitle,
    colleague,
    position,
    image,
    pipedriveFormId,
  } = blok;

  React.useEffect(() => {
    loadExternalScript('https://webforms.pipedrive.com/f/loader', { defer: true, in: 'head', force: true });
  }, []);

  return (
    <div id="specialist-form" className="bg-black py-[70px] px-8 lg:px-20 green-background-double">
      <FancyTitle
        text={title}
        subtitle={subtitle}
        textAlign="text-center lg:text-center"
        className="mx-auto text-white z-1 relative"
        marginBottom="mb-10"
        tag="h2"
      />

      <div className="flex flex-wrap justify-center text-center mb-10 gap-12 text-white z-1 relative">
        <div>
          <div>
            <img
              alt={`${colleague} - ${position}`}
              className="rounded-full mb-4 max-w-[262px]"
              src={image[0].filename}
              width={400}
              height={400}
            />
          </div>
          {colleague}
          <br />
          {position}
        </div>
      </div>

      <div id="contact-form-specialist" className="z-1 relative">
        <div
          className="pipedriveWebForms h-auto"
          data-pd-webforms={`https://webforms.pipedrive.com/f/${pipedriveFormId}`}
        >
          <script src="https://webforms.pipedrive.com/f/loader" />
        </div>
      </div>
    </div>
  );
}
